// Delegación de eventos (Este debe cargar de inmediato porque escucha los clics)
  document.addEventListener('click', function(e) {
    const target = e.target.closest('.appointment-booking, .appointment-booking-services, .appointment-booking-eval, .appointment-booking-treat, .appointment-booking-member');
    
    if (!target) return;
    e.preventDefault();
    
    if (typeof blvd === 'undefined') {
      console.error("La librería de Boulevard no ha cargado aún.");
      return;
    }

    let path = '/cart/menu';
    if (target.classList.contains('appointment-booking-services')) path = '/cart/menu/Services';
    else if (target.classList.contains('appointment-booking-eval')) path = '/cart/menu/Services/s_915084f5-e36f-4a34-ae55-db45a1abd719';
    else if (target.classList.contains('appointment-booking-treat')) path = '/cart/menu/Services/s_2c7ea5ad-079b-48d0-87f9-20ca881bc4b9';
    else if (target.classList.contains('appointment-booking-member')) path = '/cart/menu/Memberships';

    blvd.openBookingWidget({
      urlParams: {
        locationId: 'dbf8e2d3-b17a-4878-8a0a-7796dcbf617f',
        path: path,
        visitType: 'SELF_VISIT'
      }
    });
  });

  // FUNCIÓN DE OPTIMIZACIÓN: Cargar scripts pesados SOLO cuando el usuario interactúa
  function loadHeavyScripts() {
    // 1. Inyector Boulevard
    var b = { businessId: '459c8262-4ee2-46c6-8f0f-04fb0d0a5e63' };
    var c = document.createElement('script');
    c.src = 'https://static.joinboulevard.com/injector.min.js';
    c.async = true;
    c.onload = function () { blvd.init(b); };
    document.body.appendChild(c);

    // 2. Accesibilidad UserWay
    var s = document.createElement('script'); 
    s.src = 'https://acsbapp.com/apps/app/dist/js/app.js'; 
    s.async = true; 
    s.onload = function(){ acsbJS.init(); }; 
    document.body.appendChild(s);
  }

  // Escuchamos la primera interacción del usuario (scroll, movimiento del mouse o toque)
  ['scroll', 'mousemove', 'touchstart'].forEach(function(event) {
    window.addEventListener(event, function() {
      if (!window.heavyScriptsLoaded) {
        window.heavyScriptsLoaded = true;
        loadHeavyScripts();
      }
    }, { once: true }); // El evento "once" asegura que solo se ejecute la primera vez
  });